/** See `src/i18n/locales/en/companies.ts`. */
export const companies = {
  list: {
    title: 'Unternehmen',
    newCompany: 'Neues Unternehmen',
    empty: 'Für dich sind keine Unternehmen sichtbar.',
    name: 'Name',
    created: 'Erstellt',
    rowsLabel: 'die Unternehmen',
    healthTitle: 'Organisationsgesundheit',
    healthCompanies: 'Unternehmen',
    healthEditions: 'Editionen',
    healthPilots: 'Piloten',
    healthPilotsLabel: 'die Pilotenübersicht',
    healthActivePilotCount: '{{count}} Unternehmen mit einem aktiven Piloten',
  },
  detail: {
    thisCompany: 'Unternehmen',
    rename: 'Umbenennen',
    companyAdmins: 'Unternehmensadministratoren',
    delete: 'Löschen',
    departmentsTitle: 'Abteilungen',
    newDepartment: 'Neue Abteilung',
    departmentsEmpty: 'Noch keine Abteilungen.',
    departmentsLabel: 'die Abteilungen',
    name: 'Name',
    statistics: 'Statistiken',
    collectiveConsent: 'Kollektive Einwilligung',
    inForce: 'in Kraft',
    settingsTitle: 'Einstellungen',
    settingsLabel: 'die Einstellungen',
    change: 'Ändern',
    minGroupSizeLabel: 'Mindestgruppengröße für Aggregate:',
    systemDefault: 'Systemstandard',
    companyOverride: 'Unternehmensüberschreibung',
    domainsTitle: 'E-Mail-Domains',
    domainsLabel: 'die Domains',
    manage: 'Verwalten',
    domainsEmpty: 'Keine Domains registriert.',
    membersTitle: 'Mitglieder',
    membersLabel: 'die Mitglieder',
    addPerson: 'Person hinzufügen',
    membersEmpty: 'Keine Mitglieder.',
    email: 'E-Mail',
    login: 'Login',
    source: 'Quelle',
    actions: 'Aktionen',
    yes: 'ja',
    no: 'nein',
  },
  form: {
    newTitle: 'Neues Unternehmen',
    name: 'Name',
    cancel: 'Abbrechen',
    create: 'Unternehmen anlegen',
    editTitle: 'Unternehmen umbenennen',
    save: 'Speichern',
    deleteTitle: 'Unternehmen löschen',
    deleteLead:
      'Das Löschen von {{name}} beendet auch dessen Domains und Mitgliedschaften. Dies kann nicht rückgängig gemacht werden. Gib den Unternehmensnamen zur Bestätigung ein.',
    companyNameLabel: 'Unternehmensname',
    deletePermanently: 'Endgültig löschen',
    settingsTitle: 'Aggregationsschwelle',
    settingsLead:
      'Die Mindestgruppengröße, unterhalb derer Aggregate nicht angezeigt werden. Leer lassen, um zum Systemstandard zurückzukehren. Die API erzwingt eine harte Untergrenze.',
    minGroupSize: 'Mindestgruppengröße',
    domainsTitle: 'E-Mail-Domains',
    domainsLead:
      'Eine verifizierte Adresse auf einer dieser Domains nimmt ihren Inhaber bei der Anmeldung in dieses Unternehmen auf. Bestehende Mitgliedschaften bleiben erhalten, wenn eine Domain entfernt wird.',
    remove: 'Entfernen',
    addDomain: 'Domain hinzufügen',
    add: 'Hinzufügen',
    backToCompany: 'Zurück zum Unternehmen',
  },
  health: {
    title: 'Organisationsgesundheit',
    edition: 'Edition',
    editionFit: 'Fit',
    editionSoccer: 'Soccer',
    members: 'Mitglieder',
    pilotsTitle: 'Piloten',
    pilotsLabel: 'den Pilotenstatus',
    noPilots: 'Noch keine Piloten.',
    activeCount: '{{count}} aktiv',
    scaledCount: '{{count}} skaliert',
    totalCount: '{{count}} insgesamt',
    viewAllPilots: 'Alle Piloten anzeigen',
  },
} as const;
